import { useOutletContext } from "react-router-dom";
import { Tabs, Tab, Box } from "@mui/material";
import { useState } from "react";
import DisplaySettings from "./DisplaySettings/DisplaySettings";
import ColumnsSettings from "./ColumnsSettings/ColumnsSetting";
import { useFormikContext } from "formik";

const CustomOptionsPanel = () => {

    const outletContext = useOutletContext();
    const TAB_LIST = [
        { label: "Columns", value: 0 },
        { label: "Display", value: 1 },
    ];

    const { headerCorpId } = outletContext;
    const { setFieldValue  } = useFormikContext();

    const [value, setValue] = useState(0);

    return (
        <>
            <Tabs
                value={value}
                // onChange={(e, newValue) => setValue(newValue)}
                onChange={(e, newValue) => {
                    setValue(newValue);
                    setFieldValue("isMainTabsSwitch", true);
                }}
                TabIndicatorProps={{ style: { display: "none" } }}
                sx={{ minHeight: 30, maxHeight: 30, }}
            >
                {TAB_LIST.map((tab, index) => (
                    <Tab
                        key={tab.value}
                        label={tab.label}
                        value={tab.value}
                        disableRipple
                        sx={{
                            minHeight: 30,
                            maxHeight: 30,
                            px: 4,
                            borderRadius: index === 1 ? "0px 0px 5px 0px" : null,
                            textTransform: "none",
                            borderBottom: "2px solid #4384b4",
                            fontSize: "13px",
                            color: "#fff",
                            bgcolor: "#4384b4",
                            borderRight:
                                index !== TAB_LIST.length - 1
                                    ? "1px solid #4384b4"
                                    : "none",

                            "&.Mui-selected": {
                                backgroundColor: "#f2f2f2",
                                color: "#4384b4",
                            },
                        }}
                    />
                ))}
            </Tabs>
            <Box mt={1} height={"calc(100% - 20px)"} width={"100%"} p={1} overflow={"auto"} >
                {value === 0 && <ColumnsSettings />}
                {value === 1 && <DisplaySettings />}
            </Box>
        </>
    );
};

export default CustomOptionsPanel;
